export const LIVERAMP_PRELOAD_URL = 'https://launchpad.privacymanager.io/latest/launchpad.bundle.js';

export const LIVERAMP_SCRIPT_URL =
    'https://launchpad-wrapper.privacymanager.io/8062f0e0-f4fd-46ff-a003-fecc0da9e5ac/launchpad-liveramp.js';

export const GPT_SCRIPT_URL = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';

export const ADITUDE_LOAD_SCRIPT_URL =
    'https://edge.aditude.io/site/wemod-Dsqz5Cvswa/wand-longform/wand.com/prod/load.js';
